import { IUserData } from '../types';

export const getUserPrefferedName = (userData: IUserData | null): string => {
  return userData?.nickname || userData?.firstName || '';
};
